<template>
  <div>
    <div class="skeleton-table">
      <SkeletonHeader />
    </div>
    <div class="theme--light v-data-table">
      <div class="v-data-table__wrapper">
        <table>
          <caption hidden>
            Skeleton
          </caption>
          <thead class="v-data-table-header">
            <tr>
              <th
                v-for="i in countTableColumn"
                :key="i"
              >
                <div class="table-header-item">
                  <v-skeleton-loader
                    type="text"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="r in countTableRow"
              :key="r"
            >
              <td
                v-for="i in countTableColumn"
                :key="i"
              >
                <v-skeleton-loader
                  type="text"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { SkeletonHeader } from '@/components/base';

export default {
  name: 'SkeletonTable',
  components: {
    SkeletonHeader,
  },
  props: {
    countTableColumn: {
      type: Number,
      default() {
        return 5;
      },
    },
    countTableRow: {
      type: Number,
      default: 5,
    },
  },
};
</script>
